import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldStar, SpinnerGap } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@autoglas.de");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      toast.success("Willkommen zurück");
      navigate("/admin");
    } catch (e) {
      toast.error("Ungültige Anmeldedaten");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-grid opacity-20" />
      <form
        onSubmit={submit}
        className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 space-y-6 border border-slate-200"
      >
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="w-14 h-14 rounded-xl bg-slate-900 flex items-center justify-center">
            <ShieldStar size={28} weight="fill" color="white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Admin-Bereich</h1>
            <p className="text-sm text-slate-500 mt-1">Bitte anmelden, um fortzufahren.</p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">E-Mail</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 mt-1.5"
              data-testid="admin-login-email"
              required
            />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-700">Passwort</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 mt-1.5"
              data-testid="admin-login-password"
              required
            />
          </div>
        </div>

        <Button
          type="submit"
          disabled={loading}
          className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white text-base font-semibold"
          data-testid="admin-login-submit"
        >
          {loading && <SpinnerGap size={18} className="mr-2 animate-spin" />}
          Anmelden
        </Button>
      </form>
    </div>
  );
}
